var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-skeleton",class:{
    'app-skeleton--inline': _vm.inline,
    'app-skeleton--rows': _vm.pattern === 'rows',
  }},_vm._l((_vm.bars),function(bar,idx){return _c('div',{key:idx,staticClass:"app-skeleton__bar",class:`app-skeleton__bar--${bar.width}`,style:(_vm.barStyle(bar))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }